import Navbar from "../components/Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { faEarthEurope } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { AddressFormContext } from "../context/AddressFormContext";
import { useContext } from "react";
import AddressForm from "./settings/partners/AddressForm";
import axiosConfig from "../services/Axios";

function Base({ navbar = true, children }) {
  const { i18n } = useTranslation();
  const { addressForm, updateAddressForm } = useContext(AddressFormContext);

  const switchLang = (lang) => {
    i18n.changeLanguage(lang);
    axiosConfig.defaults.headers["Accept-Language"] = lang;
  };

  return (
    <>
      <AddressForm
        setIsOpen={(state) =>
          updateAddressForm({ ...addressForm, modalOpen: state })
        }
        modalIsOpen={addressForm?.modalOpen}
        partnerAddressSelected={null}
        partner={addressForm?.partner}
        cb={addressForm?.cb}
      />

      <div className="bg-gray-100">
        <ToastContainer />
        {navbar && <Navbar />}
        <div>{children}</div>
        <div className="container m-auto text-center text-sm text-gray-600"></div>
      </div>
      <div className="container m-auto">
        <div className="text-gray-600 p-8 text-sm flex items-center">
          <div>
            ©
            <a
              href="https://www.bioport-logistique.com"
              title="BIOPORT Logistique"
              target="_blank"
              className="cursor-pointer mx-1"
            >
              BIOPORT LOGISTIQUE
            </a>
            {dayjs().format("YYYY")}
          </div>
          <div className="border-l border-gray-400 ml-5 pl-5 flex items-center">
            <FontAwesomeIcon icon={faEarthEurope} className="mr-3" />
            <span
              onClick={() => switchLang("fr")}
              className={`hover:text-black cursor-pointer border-b-2 ${
                i18n.language === "fr"
                  ? "border-bioport-orange"
                  : "border-gray-200"
              }`}
            >
              FR
            </span>
            <span className="mx-1">/</span>
            <span
              onClick={() => switchLang("en")}
              className={`hover:text-black cursor-pointer border-b-2 ${
                i18n.language === "en"
                  ? "border-bioport-orange"
                  : "border-gray-200"
              }`}
            >
              EN
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Base;
